import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
export function App() {
  return <Routes data-id="element-0">
      <Route path="/" element={<LandingPage data-id="element-2" />} data-id="element-1" />
      <Route path="/contact" element={<ContactPage data-id="element-4" />} data-id="element-3" />
      <Route path="/privacy" element={<PrivacyPage data-id="element-6" />} data-id="element-5" />
      <Route path="/terms" element={<TermsPage data-id="element-8" />} data-id="element-7" />
    </Routes>;
}